'use client';

import { useEffect } from 'react';

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        console.error('[global error]', error);
    }, [error]);

    const locale = typeof window !== 'undefined' && window.location.pathname.startsWith('/ar') ? 'ar' : 'en';
    const isAr   = locale === 'ar';

    return (
        <html lang={locale} dir={isAr ? 'rtl' : 'ltr'}>
            <head>
                <title>{isAr ? 'خطأ — محمد صابر' : 'Error — Mohamed Saber'}</title>
                <meta name="description" content={isAr ? 'حدث خطأ غير متوقع' : 'An unexpected error occurred'} />
            </head>
            <body style={{ margin: 0, fontFamily: 'system-ui, sans-serif', background: '#0a0a0a', color: '#f5f5f5' }}>
                <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem', textAlign: 'center' }}>
                    <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '0.75rem' }}>
                        {isAr ? 'حدث خطأ غير متوقع' : 'Something went wrong'}
                    </h1>
                    <p style={{ color: '#a3a3a3', marginBottom: '1.5rem', maxWidth: '28rem' }}>
                        {isAr
                            ? 'حدث خطأ فادح. يمكنك المحاولة مجدداً.'
                            : 'A critical error occurred. You can try again.'}
                    </p>
                    <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', justifyContent: 'center' }}>
                        <button
                            onClick={reset}
                            style={{ padding: '0.625rem 1.25rem', borderRadius: '0.75rem', background: '#f97316', color: '#fff', border: 'none', fontWeight: 600, fontSize: '0.875rem', cursor: 'pointer' }}
                        >
                            {isAr ? 'حاول مجدداً' : 'Try again'}
                        </button>
                        <a
                            href={`/${locale}`}
                            style={{ padding: '0.625rem 1.25rem', borderRadius: '0.75rem', background: 'transparent', color: '#f5f5f5', border: '1px solid #333', fontWeight: 500, fontSize: '0.875rem', textDecoration: 'none' }}
                        >
                            {isAr ? 'الصفحة الرئيسية' : 'Go home'}
                        </a>
                    </div>
                </div>
            </body>
        </html>
    );
}
